import { KYBStatus } from '@/api/common.types';
import { useCheckKYBStatus } from '@/api/queryHooks/useKYBController';

export const useIsKYBVerified = ({ isEnabled = true }: { isEnabled?: boolean } = {}) => {
  const { data: KYBStatusData } = useCheckKYBStatus({ refetchOnMount: true, enabled: isEnabled });
  return KYBStatusData?.status === KYBStatus.CLEAR || KYBStatusData?.status === KYBStatus.BIOMETRIC_REQUIRED;
};
